import type { FaireProductEntity } from "../../entity_types/product";

export const p_s7mr3prvba: FaireProductEntity = {
  token: "p_s7mr3prvba",
  type: "product",
  name: "Pink Bandana Fringe Crossbody",
  brandToken: "b_5m4wqw135i",
  brandName: "Panache Apparel Co.",
  imageUrl: "https://cdn.faire.com/fastly/2318dc5f2595e526b7af192fcf805859e9423986ff496b2b30e957b294074af9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/620a337883603c39738bf92038143127d1599dfc1e60f18fc272f444b7bb8e8e.jpeg",
    "https://cdn.faire.com/fastly/e564c359a736041b4eba2514d6d926e814e98f8f3f47da5955bbc00eff13bd5c.jpeg"
  ],
  priceDollars: 37.95,
  description: "A pink bandana fringe crossbody featuring a classic paisley print, designed with a long crossbody strap and suede leather fringe detailing for a stylish western-inspired look. Roomy interior is perfect for carrying daily essentials while adding a statement touch to any outfit.\n\n14\" W x 10\" H\n\n100% Cotton\n\nMin. Qty: 2",
  tags: [],
  msrpDollars: 94.88,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:05:44.364Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
